module.exports = __webpack_public_path__ + "static/media/sat-5.b39818e1.pdf";